import { render, staticRenderFns } from "./PageImportAllergenes.vue?vue&type=template&id=17b6454b&"
import script from "./PageImportAllergenes.vue?vue&type=script&lang=js&"
export * from "./PageImportAllergenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b6454b')) {
      api.createRecord('17b6454b', component.options)
    } else {
      api.reload('17b6454b', component.options)
    }
    module.hot.accept("./PageImportAllergenes.vue?vue&type=template&id=17b6454b&", function () {
      api.rerender('17b6454b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administration/PageImportAllergenes.vue"
export default component.exports